import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import {
  useAddSourceMutation,
  useUpdateSourceMutation,
} from "../../cdsApiSlice";
import {  setSource } from "../../cdsSlice";
import "./MainSourceExterne.scss";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useParams } from "react-router-dom";
import { setToast } from "../../../../app/appSlice";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "primereact/confirmdialog";

interface IngestionProps {
  minus: () => void;
}

export const Ingestion = ({ minus }: IngestionProps) => {
  const [visibleDialog, setVisibleDialog] = useState(false);
  const navigate = useNavigate();
  const toast: any = useRef(null);
  const dispatch = useAppDispatch();
  const source: any = useAppSelector((state) => state.cds.source);
  const [addSource, statusAddSource] = useAddSourceMutation();
  const [updatetSource, statusUpdateSource] = useUpdateSourceMutation();
  const { id } = useParams();
  const sasWarningMessage = useAppSelector(
    (state) => state.app.config.sasWarningMessage
  );
  const { t } = useTranslation();
  // icon-warning.svg


    // Catching event's sucess and error to launch toast lessages

  useEffect(() => {
    if(statusUpdateSource.isSuccess) {
      dispatch(
        setToast({
          severity: "success",
          title: "Source externe",
          content: `source ${statusUpdateSource.data.nom} modifiée !`,
          life: 5000,
        })
      );
      navigate(`/library/sources/${statusUpdateSource.data.id}`);
    }

    if(statusUpdateSource.isError) {
      dispatch(
        setToast({
          severity: "error",
          title: "Erreur !",
          content:  `Impossible de modifier la source ${source.nom}`,
          life: 20000,
        })
      )
    }
  },[statusUpdateSource])

  const SubmitButton = (status: any, action: string) => {
    if (status.isLoading)
      return (
        <Button className="m-2 p-button p-button-sm">
          <div className="is__loading">
            {action} <FontAwesomeIcon icon="spinner" spin />
          </div>
        </Button>
      );

    return (
      <Button
        className="m-2 p-button p-button-sm"
        type="submit"
        onClick={() => sendSource()}
      >
        <div>{action}</div>
      </Button>
    );
  };

  const sendSource = async () => {
    const labelsToMetadata = Object.keys(source.selectedLabels).map(labelID => ({
        nom: labelID,
        valeur: Array.isArray(source.selectedLabels[labelID]) ? source.selectedLabels[labelID].join(", ") : source.selectedLabels[labelID]
    }));

    let metadonnee = [
      ...source.CustomMetaData.map((i: any) => ({
        nom: i.name,
        valeur: i.value,
      })),
      ...source.protocoleDatas,
      ...labelsToMetadata
    ];
    metadonnee.push({
      nom: "source_type_donnee",
      valeur: source.typeDeDonnee.name,
    });
    metadonnee.push({
      nom: "source_format_donnee",
      valeur: source.formatDeDonnee.name,
    });
    metadonnee.push({ nom: "source_uri", valeur: source.uri });
    metadonnee.push({ nom: "source_utilisateur", valeur: source.utilisateur });
    metadonnee.push({ nom: "source_protocole", valeur: source.protocole });
    metadonnee.push({ nom: "source_organisme", valeur: source.organisme });
    console.log(source);
    if (!id) {
      try {
        const data = await addSource({
          nom: source.nom,
          motDePasse: source.motDePasse,
          sas: source.sas,
          guid: [source.espaceDeStockageValue.guid],
          idDomaine: source.domaine.id,
          description: source.description,
          metadonnees: metadonnee,
        }).unwrap();
        dispatch(
          setToast({
            severity: "success",
            title: "Source externe",
            content: `source ${data.nom} ajoutée !`,
            life: 5000,
          })
        );
          navigate(`/library/sources/${data.id}`);
      } catch (e) {
        dispatch(
          setToast({
            severity: "error",
            title: "Erreur !",
            content: `Impossible de créer la source ${source.nom}`,
            life: 20000,
          })
        );
      }
    } else {
       updatetSource({
          id: source.id,
          nom: source.nom,
          motDePasse: source.motDePasse,
          sas: source.sas,
          guid: [source.espaceDeStockageValue.guid],
          idDomaine: source.domaine.id,
          description: source.description,
          metadonnees: metadonnee,
        })
        
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        header={t("message.disable-sas.header")}
        message={t("message.disable-sas.body")}
        contentClassName="text-2xl"
        accept={() => dispatch(setSource({ sas: false }))}
        reject={() => dispatch(setSource({ sas: true }))}
        visible={visibleDialog}
        acceptLabel={t("button.confirm")}
        rejectLabel={t("button.cancel")}
        closable={false}
        onHide={() => setVisibleDialog(false)}
      />
      <div className="contentForm">
        <div className="formSourceExt">
          <div className="labelSourceExterne mb-2">
            Passage par la sas<span className="star">*</span>
          </div>
          <div className="sas">
            <div className="mr-3">
              <InputSwitch
                onChange={(e: any) => {
                  if (source.sas) {
                    setVisibleDialog(true);
                  }
                  dispatch(setSource({ sas: e.value }));
                }}
                checked={source.sas}
              />
            </div>
            <div>{source.sas ? "Oui" : "Non"}</div>
          </div>
          {sasWarningMessage && (
            <div className="flex flex-wrap align-items-center mt-2">
              <i className="pi pi-exclamation-triangle text-2xl text-yellow-500 mr-3"></i>{" "}
              <div className="labelSourceExterne">{sasWarningMessage}</div>
            </div>
          )}
        </div>
      </div>

      <div className="flex">
        <div className="bottomButtonCancel">
          <Button
            label={"ANNULER"}
            type="button"
            onClick={() => {
              navigate("/library/sources");
            }}
            className="m-2 p-button-text p-button-sm"
          />
        </div>

        <div className="bottomButton">
          <Button
            label={"PRECEDENT"}
            type="button"
            onClick={() => {
              minus();
            }}
            className="m-2 p-button-outlined p-button-sm"
          />
          {id
            ? SubmitButton(statusUpdateSource, "MODIFIER")
            : SubmitButton(statusAddSource, "ENREGISTRER")}
        </div>
      </div>
    </>
  );
};
